// for scroll effect on homepage
let scrollTicking = false;
let pageHeight = document.body.scrollHeight;

// recalculate page height
const recalculatePageHeight = () =>{
     pageHeight = document.body.scrollHeight;
};
const parallaxEffect = () => {
    if (!scrollTicking) {
        const campusImg = document.querySelector('.campus-image img')
        if (window.innerWidth > 768) {
            window.requestAnimationFrame(() => {
                // calculate how much percent to apply 
                const percentScrolled = ((window.scrollY / pageHeight) * 30).toFixed(3);
                campusImg.style.objectPosition = `50% ${percentScrolled < 100 ? percentScrolled : 100}%`
                scrollTicking = false;
            });
            scrollTicking = true;
        } else {
            campusImg.style.objectPosition = `50% 40%`
        }
    }
}

// for trapping focus within the giving modal
const modalTrap = e => {

    // check if modal trap is active. If not, don't run this
    if (!document.body.getAttribute('data-modalTrap')) {
        return;
    }

    // grab keycode. If none for some reason, exit the function
    const code = 'code' in e ? e.code : null;
    if (code == null) {
        return;
    }

    const modalId = document.body.getAttribute('data-modalTrapId');
    const modal = document.getElementById(modalId);
    const trappedEls = modal.querySelectorAll(`
        input:not([disabled]), 
        textarea:not([disabled]), 
        select:not([disabled]), 
        button:not([disabled]), 
        a:not([disabled]), 
        *[tabindex]`);

    const filteredEls = [].filter.call(trappedEls, el => {
        return el.tabIndex > -1 && el.style.display != 'none'
    });

    const first = filteredEls[0];
    const last = filteredEls[filteredEls.length - 1];

    // if tabbing, check if the current selected el is the last el
    if (code == 'Tab' && e.shiftKey !== true) {
        if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
        }
    }

    // if shift-tabbing
    if (code == 'Tab' && e.shiftKey === true) {
        if (document.activeElement === first) {
            last.focus();
            e.preventDefault();
        }
    }
}
document.addEventListener('keydown', modalTrap);

const activateModalTrap = modalId => {
    document.body.setAttribute('data-modalTrap', true);
    document.body.setAttribute('data-modalTrapId', modalId);
}

const decactivateModalTrap = () => {
    document.body.removeAttribute('data-modalTrap');
    document.body.removeAttribute('data-modalTrapId');
}

// add parrallax effect to scroll image
document.addEventListener('DOMContentLoaded', () => {    
    recalculatePageHeight();
    document.addEventListener('scroll', parallaxEffect);

    printBtn = document.addEventListener('click', e => {
        const el = e.target;
        const className = 'className' in el !== false ? el.className : null;

        if (className === 'print-button') {
            window.print();
        }
    })
});

// handler for most giving form functionality
jQuery(document).bind('gform_post_render', function() {

    /* A) Helpers and Variables
     * */

    // 1. HELPER FUNCTIONS
    const findAncestor = (el, cls) => {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }
    const removeClass = (el, classname) => {
        if (typeof el === 'undefined') return;
        el.className = el.className.replace(" " + classname, "");
    }
    const addClass = (el, classname) => {
        el.className += " " + classname;
    }
    const hasClass = (el, classname) => {
        return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
    }

    // set the aria-table's row counter based on how many rows there are
    const setRowArias = tableEl => {
        const allRows = tableEl.querySelectorAll('[role="row"]');
        tableEl.setAttribute('aria-rowcount', allRows.length);
        [].forEach.call(allRows, (el, i) => el.setAttribute('aria-rowindex', i+1));
    }

    // set the correct IDs for the various repeating field divs
    const setCorrectRFIDs = () => {
        
        // grab each repeater cell 
        const allCells = document.querySelectorAll('.gfield_repeater_item .gfield_repeater_cell');

        // end the function if there are no rf cells
        if (allCells.length == 0) {
            return
        }
        
        // filter out the cells that don't have inputs
        const inpCells = [].filter.call(allCells, cell => cell.querySelector('input') !== null);

        // end the function if there are no input cells
        if (inpCells.length == 0) {
            return;
        }

        // go through each input-containing cell
        [].forEach.call(inpCells, cell => {

            // Get the ID we need from the input itself
            const cell_inp = cell.querySelector('input');
            const idNum = cell_inp.id.replace('input', '');

            // Find the enclosing div.gfield, change the ID to match the number of the input
            const gfield = cell.querySelector('.gfield');
            gfield.setAttribute('id', `field${idNum}`);

            // change instruction div ID (otherwise their duplicates)
            const instruction = cell.querySelector('.instruction');
            if (instruction) {
                instruction.setAttribute('id', `gfield_instruction${idNum}`);
            }
            
            // See if there is a sibling div.validation_message.
            const error = cell.querySelector('.validation_message');

            // If so, give it an id and set the input's aria-described by to that. Otherwise, set input's aria-describedby to instruction div
            if (error !== null) {
                error.setAttribute('id', `error${idNum}`);
                cell_inp.setAttribute('aria-describedby', `error${idNum}`);
            } else if (instruction) {
                // otherwise, set the aria-describedby to the instruction div
                cell_inp.setAttribute('aria-describedby', `gfield_instruction${idNum}`);
            } else {
                cell_inp.removeAttribute('aria-describedby');
            }
        })
    }

    // classes
    const c_desInputContainer = '.gfield_repeater_container';
    const c_desInputs = '.gfield_repeater_item .gfield_repeater_cell:first-child input';
    const c_dollarInputs = '.gfield_repeater_item .gfield_repeater_cell:nth-child(2) input';
    const c_dollarInputsChanged = '.gfield_repeater_item .gfield_repeater_cell:nth-child(2) input[data-changed]';
    const c_dollarInputsUnchanged = '.gfield_repeater_item .gfield_repeater_cell:nth-child(2) input:not([data-changed])';
    const c_percentInputsChanged = '.gfield_repeater_item .gfield_repeater_cell:nth-child(3) input[data-changed]';
    const c_percentInputsUnchanged = '.gfield_repeater_item .gfield_repeater_cell:nth-child(3) input:not([data-changed])';
    const c_percentageInputs = '.gfield_repeater_item .gfield_repeater_cell:nth-child(3) input';
    const c_remainingTotal = '.remaining_total input';
    const c_remainingPercent = '.remaining_percent input';
    const c_desFilter = '.des-filter';
    const c_desFilterBtn = '.des-filter-btn';
    const c_amountInput = '.amount input';

    // 2. INPUT VARIABLES
    // amount input
    const amountInput = document.querySelector('.amount input');

    // gtype buttons
    const gtypeButtons = document.querySelectorAll('.gtype input');

    

    // designation option radios
    const dtypeButtons = document.querySelectorAll('.dtype input');

    // dollar row buttons
    const dolButtons = document.querySelectorAll('.dollar-buttons button');
    const stdAmounts = [50, 100, 200, 500, 1000];
    const recurAmounts = [5, 10, 20, 50, 100];

    // other des section
    const otherDesWrapper = document.querySelector('.other-des-wrapper');
    const otherDes = document.querySelector('.other-designation');
    const otherDesResults = document.getElementById('desResults');
    const otherDesCloseBtn = document.getElementById('modalClose');

    // other des table
    const repeaterCont = document.querySelector(c_desInputContainer);

    // other des err message container
    const errMsg = document.querySelector('.other-designation .errMsg');

    // buttons for other designation checkboxes section
    const otherCancel = document.getElementById('cancelOther');
    const otherContinue = document.getElementById('continueOther');

    // div that will contain the designation checkboxes
    const designationCheckboxes = document.querySelector('.designation-checkboxes');

    // other designation filter and filter search button
    const desFilter = document.getElementById('desFilter');
    const desSearchBtn = document.getElementById('desSearchBtn');

    // format the categories (allDes is included in an HTML Script Element in the actual gravity form)
    const theCats = allDes.reduce((prev, cur) => {
        return prev.indexOf(cur.category) === -1 ? [...prev, cur.category] : prev; 
    }, []);    

    // all the repeater items
    const repeaterItems = document.querySelector('.gfield_repeater_items');

    // biographical container and input
    const bioContainers = document.querySelectorAll('.gform_wrapper .bioContainer');
    const bioInputs = document.querySelectorAll('.gform_wrapper .bioContainer input');

    // campus image
    const campusImg = document.querySelector('.campus-image img')

    // isAthletics (for email routing)
    const c_athleticsRadio = '.isAthletics input';
    const athleticsRadio = document.querySelector('.isAthletics input');
    const isAthletics = () => {
        athleticsRadio.checked = true;
        jQuery(c_athleticsRadio).change();
    }
    const isNotAthletics = () => {
        athleticsRadio.checked = false;
        jQuery(c_athleticsRadio).change();
    }

    const determineAthletics = str => str == 'Athletics' || str == 'Men\'s Sports' || str == 'Women\'s Sports';

    const setAthleticsRadioValue = () => {
        // determine if there are Athletics designations in the mix
        const hasAthletics = document.querySelectorAll(c_desInputs + '[data-athletics="true"]').length > 0;

        // if so, check off the proper input. If not, remove check
        if ( hasAthletics ) {
            isAthletics();
        } else {
            isNotAthletics();
        }
    }

    // linked designation (when query arg is provided (and make it read only on load)
    const linkedDesignation = document.querySelector('.linked-designation input') != null 
        ? document.querySelector('.linked-designation input')
        : document.querySelector('.linked-designation textarea');
    
    if (linkedDesignation) {
        linkedDesignation.readOnly = true;
        // check if linked designation is in the list of designations
        const foundDes = allDes.find( des => des.value == linkedDesignation.value.replace('’', '\'') );
        if (foundDes && determineAthletics(foundDes.category)) {
            isAthletics();
        }
    }
    
    // 3. FORM DISPLAY FUNCTIONS
    // show and hide other designation dependent sections
    const hideOtherDes = () => { 
        if (otherDesWrapper.style.display != 'none') {
            otherDesWrapper.style.display = 'none';
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1)
            decactivateModalTrap();
        }
        otherDesResults.removeAttribute('aria-live');
        removeCustomDesInModal();
        
    }
    const showOtherDes = () => {
        otherDesWrapper.style.display = 'block';
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100vw';
        displayCustomDesInModal();
        countOtherDesResults();
        otherDesResults.setAttribute('aria-live', 'polite');
        jQuery(otherDesWrapper).change();
        otherDes.focus();
        activateModalTrap('other-designation');
    };

    // show and hide the repeating fields (other designation, repeater)
    const hideRep = () => {
        document.querySelector('.gfield_repeater_wrapper').style.display = 'none';
    }
    const showRep = () => {
        document.querySelector('.gfield_repeater_wrapper').style.display = 'block';
    }

    // check if repeater inputs have values
    const repInpsHaveValues = () => {
        const repeaterInps = document.querySelectorAll('.gfield_repeater_item .gfield_repeater_cell:first-child input');
        return [].some.call(repeaterInps, inp => inp.value !== '' || inp.hasAttribute('data-custom'));
    }

    // get the total
    const getTotal = () => document.querySelector('.amount input').value ?
        document.querySelector('.amount input').value.replace(/[^0-9.]/g, '') :
        '';

    // callable function for formatting the values of dollar and percentage inputs
    const editDollars = ({currentTarget}) => {
        currentTarget.value = currentTarget.value.replace(/[^0-9.]/g, '');
        if (currentTarget.value.length != 0) {
            currentTarget.value = '$' + ((+currentTarget.value).toFixed(2)).replace(/\.$/, '').replace('.00', '');
        }
    }
    const editPercentage = ({currentTarget}) => {
        currentTarget.value = currentTarget.value.replace(/[^0-9.]/g, '');
        if (currentTarget.value.length != 0) {
            currentTarget.value = ((+currentTarget.value).toFixed(1)).replace(/\.$/, '').replace('.0', '');
        }
    }

    // add up percents for other designations 
    const updateRemainingPercent = () => {
        const percentageInps = document.querySelectorAll(c_percentageInputs);
        const percentTotal = [].reduce.call(percentageInps, (prev, cur) => cur.value.replace(/[^0-9\-]/g, '') != '' ? 
            prev + (+cur.value.replace(/[^0-9.\-]/g, '')) : 
            prev, 
        0);
        const remaining = 100 - percentTotal;
        const remPerInp = document.querySelector(c_remainingPercent);
        remPerInp.value = remaining.toFixed(1);
        totalPercentageRO.value = ((percentTotal.toFixed(1)).toString().replace('.0', '')) + '%';
        jQuery(c_remainingPercent).change();
    }   

    // add up dollars for other designations
    const updateRemainingTotal = () => {
        const total = getTotal();
        const dollarInps = document.querySelectorAll(c_dollarInputs);
        const dolTotal = [].reduce.call(dollarInps, (prev, cur) => cur.value.replace(/[^0-9\-]/g, '') != '' ? 
            prev + (+cur.value.replace(/[^0-9.\-]/g, '')) : 
            prev, 
        0);
        const remaining = total - dolTotal;
        const remTotalInp = document.querySelector(c_remainingTotal);
        remTotalInp.value = remaining.toFixed(2);
        totalDollarRO.value = '$' + (dolTotal.toFixed(2)).toString().replace('.00', '');
        jQuery(c_remainingTotal).change();
    }   

    // make percentage inputs readOnly if only one row, or remove readOnly if more 
    const decidePercentageInputROStatus = () => {
        const percentageInputs = document.querySelectorAll(c_percentageInputs);
        const percentageInputContainers = document.querySelectorAll('.gfield_repeater_item .gfield_repeater_cell:nth-child(3) .ginput_container');
        if (percentageInputs.length == 1) {
            percentageInputs[0].readOnly = true;
            if (!hasClass(percentageInputContainers[0], 'readOnly')) {
                addClass(percentageInputContainers[0], 'readOnly');
            }
        } else {
            [].forEach.call(percentageInputs, inp => inp.readOnly = false);
            [].forEach.call(percentageInputContainers, cont => removeClass(cont, 'readOnly'));
        }
    }
        
    // remove the data-changed attribute from all otherDes dollar inputs
    const removeDataChangedAttrs = () => {
        const dollarInputs = document.querySelectorAll(c_dollarInputs);
        const percentInputs = document.querySelectorAll(c_percentageInputs);
        
        [].forEach.call(dollarInputs, inp => {
            if (inp.hasAttribute('data-changed')) {
                inp.removeAttribute('data-changed');
            }   
        });

        [].forEach.call(percentInputs, inp => {
            if (inp.hasAttribute('data-changed')) {
                inp.removeAttribute('data-changed');
            }   
        });
    }

    // function to remove a designation repeating field
    const removeDesRF = (desInput, isRemoveButton = false) => {

        // With input/remover button, find the repeating field wrapper 
        const desWrapper = findAncestor(desInput, 'gfield_repeater_item');

        const isCustom = desWrapper.getAttribute('data-custom') == 'true';

        // if we need to remove the checked boxes from the modal, do so 
        if (isRemoveButton) {

            // find the name input and the value. This is the desingation's name
            const nameInp = desWrapper.querySelector('.gfield_repeater_cell:first-child input')
            const desName = nameInp.value;

            // use the name to find the association modal checkbox, and uncheck it
            const desCheckbox = document.querySelector(`.designation-checkboxes input[data-desvalue="${desName}"]`);
            
            // check to make sure a checkbox is there before trying to uncheck it (custom des on load may not have one)
            if (desCheckbox) {
                desCheckbox.checked = false;
            }
        }

        // determine if desWrapper is the only repeater item left
        const onlyOneItem = document.querySelectorAll('.gfield_repeater_item').length == 1;

        // since we're removing a des, remove all data-changed attributes from dollar inputs
        removeDataChangedAttrs();

        // if there's only one item, just remove the input values and hide the container
        if (onlyOneItem) {
            const itemInps = desWrapper.querySelectorAll('input');
            [].forEach.call(itemInps, inp => inp.value = '');
            hideRep();
        } else {
            // if there's multiple items, find the remove button then use GF's remove function
            const remover = desWrapper.querySelector('.remove_repeater_item');
            gformDeleteRepeaterItem(remover);
        }

        // with designation removed...
        if (isRemoveButton) {
            
            // allocate dollars and percentages
            const dollarEls = document.querySelectorAll(c_dollarInputs);
            const dollarElHasValue = [].some.call(dollarEls, inp => inp.val !== '');
            if (dollarElHasValue) {
                allocateDollarsInitial(dollarEls.length);
                allocatePercentages();
            }

            // if only one row, make percentage input read only. Otherwise, remove readOnly from all of them
            decidePercentageInputROStatus();

            // make sure des in local storage is correct (only when modal's continue click not used)
            saveRepeatingInputsLS();

            // check for any athletics buttons. Set athletics radio button appropriately if so.
            setAthleticsRadioValue();
        }
        setRowArias(repeaterCont);
        setCorrectRFIDs();
    }

    // function to add the necessary custom attributes to Repeating Field elements
    const addAttributesToRF = (des, isCustom, isCustomLoad, el = null) => {

        const theEl = el !== null ? el : document.querySelector('.gfield_repeater_item:last-child');
        
        // add the aria labels to the field we added
        theEl.setAttribute('role', 'row');

        // add aria-labels to each cell
        const firstEl = theEl.querySelector('.gfield_repeater_cell:nth-child(1)');
        firstEl.setAttribute('role', 'rowheader');
        firstEl.setAttribute('aria-colindex', '1');

        const secondEl = theEl.querySelector('.gfield_repeater_cell:nth-child(2)');
        secondEl.setAttribute('role', 'cell');
        secondEl.setAttribute('aria-colindex', '2');

        const thirdEl = theEl.querySelector('.gfield_repeater_cell:nth-child(3)');
        thirdEl.setAttribute('role', 'cell');
        thirdEl.setAttribute('aria-colindex', '3');

        const fourthEl = theEl.querySelector('.gfield_repeater_cell:nth-child(4)');
        fourthEl.setAttribute('role', 'cell');
        fourthEl.setAttribute('aria-colindex', '4');

        const customName = isCustomLoad ? des.value : '';

        const rowDesInput = theEl.querySelector('.gfield_repeater_cell:first-child input')
        rowDesInput.value = !isCustom ? des.value : customName;
        rowDesInput.placeholder = !isCustom ? null : 'Enter the Designation Name';
        rowDesInput.ariaLabel = 'Designation Name';
        rowDesInput.readOnly = !isCustom ? 
            true :
            false;
    
        if (isCustom) {
            theEl.setAttribute('data-custom', 'true');
            rowDesInput.setAttribute('data-custom', 'true');
            
            // check number of repeating custom fields and tag the wrapper with it (for removal and adding purposes)
            const customId = Date.now();
            theEl.setAttribute('data-desvalue', `custom-${customId}`);
            rowDesInput.setAttribute('data-desvalue', `custom-${customId}`);
            
            // if this is a custom designation, make sure that the custom des's name gets saved to local storage on change
            rowDesInput
                .addEventListener('change', e => {
                    saveRepeatingInputsLS();
                    changeRemoveButtonAriaLabelName(e.currentTarget);
                });
        } else {

            // determine if it's athletics
            const athleticsStatus = 'category' in des ? determineAthletics(des.category) : false;

            // set proper statuses
            if (athleticsStatus) {
                theEl.setAttribute('data-athletics', 'true')
                rowDesInput.setAttribute('data-athletics', 'true');
            } else {
                theEl.removeAttribute('data-athletics')
                rowDesInput.removeAttribute('data-athletics');
            }

            theEl.removeAttribute('data-custom');
            rowDesInput.removeAttribute('data-custom');
            theEl.removeAttribute('data-desvalue');
            rowDesInput.removeAttribute('data-desvalue');

        }
        // aria attributes for delete button
        const removeBtn = theEl.querySelector('.gfield_repeater_cell:nth-child(4) button');
        const desName = !isCustom ? des.value : customName;
        removeBtn.setAttribute('aria-label', `Remove Gift Designation - ${desName == '' ? 'Currently Unnamed' : desName}`);
    }

    const changeRemoveButtonAriaLabelName = inp => {

        // get repeater item container
        const container = findAncestor(inp, 'gfield_repeater_item');

        // get the remove button
        const removeButton = container.querySelector('.gfield_repeater_cell:nth-child(4) button');

        // get name of des
        const desName = inp.value != '' ? inp.value : 'Currently Unnamed';

        // change name in aria label to the designation name
        removeButton.setAttribute('aria-label', `Remove Gift Designation - ${desName}`);

    }

    const addDesRF = (des, isCustomLoad = false) => {

        // determine whether we have added any fields yet
        const firstInp = document.querySelector('.gfield_repeater_item:first-child .gfield_repeater_cell:first-child input');
        const addedFields = firstInp.hasAttribute('data-custom') || firstInp.value !== '' ? true : false;

        // if we have added a field before, then find the last repeater field's adder button, then click it
        if (addedFields) {
            const rfAdder = document.querySelector('.gfield_repeater_item:last-child .add_repeater_item');
            gformAddRepeaterItem(document.querySelector('.gfield_repeater_item:last-child .add_repeater_item'));
        }

        // fill in the information based on the designation and disable it if not custom des
        const isCustom = des.value == 'enter' || isCustomLoad;

        addAttributesToRF(des, isCustom, isCustomLoad)

        // add event handlers to dollar and percent inputs, and remover button
        document.querySelector('.gfield_repeater_item:last-child .gfield_repeater_cell:nth-child(2) input')
            .addEventListener('change', e => {
                editDollars(e);
                handle_dollar_change(e);
            });
        document.querySelector('.gfield_repeater_item:last-child .gfield_repeater_cell:nth-child(3) input')
            .addEventListener('change', e => {
                editPercentage(e);
                handle_percent_change(e);
            });
        
        const removeBtn = document.querySelector('.gfield_repeater_item:last-child .gfield_repeater_cell:nth-child(4) button');
        
        removeBtn.addEventListener('click', e => removeDesRF(removeBtn, true)); // 2nd arg means this is for a delete button

        // since we're adding a new input, remove the data-changed attributes from all dollar fields
        removeDataChangedAttrs();

        // reveal the container
        showRep();

        setRowArias(repeaterCont);
        setCorrectRFIDs();
    } 

    
    const removeAllDesRF = (keepLS = false) => {

        const removers = document.querySelectorAll('.gfield_repeater_item:not(:first-child) .remove_repeater_item');
        [].forEach.call(removers, remover => gformDeleteRepeaterItem(remover));

        // remove input values from the first repeaters
        const firstRemInps = document.querySelectorAll('.gfield_repeater_item:first-child input');
        [].forEach.call(firstRemInps, inp => inp.value = '');

        // display none the repeating field container
        hideRep();

        // turn off Athletics checkbox if selected
        isNotAthletics();

        // delete local storage of custom designations, unless we specify not to
        if (!keepLS) {
            deleteRepeatingInputsLS(); 
        }

        setRowArias(repeaterCont);
        setCorrectRFIDs();
        
    }

    const saveRepeatingInputsLS = () => {

        // get all repeater rows
        const repeaterRows = document.querySelectorAll('.gfield_repeater_item');

        // create an array of object, each el a row
        const data = [].map.call(repeaterRows, (el, i) => {
            const name = el.querySelector('.gfield_repeater_cell:nth-child(1) input').value;
            const amount = el.querySelector('.gfield_repeater_cell:nth-child(2) input').value;
            const percent = el.querySelector('.gfield_repeater_cell:nth-child(3) input').value;
            const isCustom = el.getAttribute('data-custom') == 'true';
            const isAthletics = el.getAttribute('data-athletics') == 'true';

            return ({
                name,
                amount,
                percent,
                isCustom,
                isAthletics
            });
        }).filter(el => el !== null);

        window.localStorage.setItem('repeatingInputs', JSON.stringify(data));
    }

    const deleteRepeatingInputsLS = () => {
        window.localStorage.removeItem('repeatingInputs')
    }

    const loadRepeatingInputsLS = () => {

        // if there's validation errors, remove any of the designations that get autoloaded on the page by the browser
        const wasSubmitted = document.querySelector('.gform_validation_errors') != null;
        
        // grab first rf's des, dollar, and percent input values, to check whether we need to load the des
        const firstDes = document.querySelector('.gfield_repeater_item:first-child .gfield_repeater_cell:first-child input').value;
        const firstDol = document.querySelector('.gfield_repeater_item:first-child .gfield_repeater_cell:nth-child(2) input').value;
        const firstPer = document.querySelector('.gfield_repeater_item:first-child .gfield_repeater_cell:nth-child(3) input').value;
       
        // passing true to removeAllDesRF will stop it from deleting the local storage of custom designations. We still need that
        if ( wasSubmitted ) {

            if (checked_dtype.value == 'Other') { 

                // if it was submitted, then the repeating fields will load. We just need to designate what is and isn't custom
                const allRFs = document.querySelectorAll('.gfield_repeater_item');

                [].forEach.call(allRFs, rf => {
                    const inpDes = rf.querySelector('.gfield_repeater_cell:first-child input');
                    const theDesArr = allDes.filter(des => des.value == inpDes.value);
                    const theDes = theDesArr.length > 0 ? theDesArr[0] : null;
                    if (theDes) {
                        addAttributesToRF(theDes, false, false, rf);
                    } else {
                        addAttributesToRF({value: inpDes.value}, true, true, rf);
                    }

                    // once the designation fields have attributes, allow the delete buttons to function normally
                    const removeBtn = rf.querySelector('.gfield_repeater_cell:nth-child(4) button');
                    removeBtn.addEventListener('click', e => removeDesRF(removeBtn, true)); // 2nd arg means this is a delete buttons
                })

                // if there's only one row, disable the percent input. Otherwise, enable all of them
                decidePercentageInputROStatus();

                // set the row arias
                setRowArias(repeaterCont);
                setCorrectRFIDs();
            }
            return;
        }

        // cancel if no repeating inputs in storage, or if first row doesn't match what was loaded
        const cancelRFLoad = window.localStorage.getItem('repeatingInputs') == null;

        const data = cancelRFLoad ? null : JSON.parse(window.localStorage.getItem('repeatingInputs'));

        const cancelRFFill = 
            cancelRFLoad ||
            data.length == 0 ||
            data[0].name != firstDes &&
            data[0].amount != firstDol &&
            data[0].percent != firstPer; 

        if (cancelRFLoad || cancelRFFill) {
            
            // but if dtype is other and there's no designations, deselect the Other input
            const checked_dtype = document.querySelector('.dtype input:checked');

            if (checked_dtype.value == 'Other') {
                // get values of first  
                checked_dtype.checked = false;
                jQuery(checked_dtype).change();
                hideRep();
            }

            return;
        }

        // at this point, we're loading the designations
        data.forEach( (el, i) => {

            const isCustom = el.isCustom;

            // if it's first repeating row (which user's browser will load), add appropriate des status and activate the delete button
            if (i == 0 && !wasSubmitted) {
                addAttributesToRF({
                    value: el.name, 
                    category: el.isAthletics ? 'Athletics' : null
                }, isCustom, isCustom);
                const removeBtn = document.querySelector('.gfield_repeater_item:last-child .gfield_repeater_cell:nth-child(4) button');
                removeBtn.addEventListener('click', e => removeDesRF(removeBtn, true));
                
            } else {

                // for every other row, add the entire row (addDesRF handles custom des status when 2nd arg is "true")
                if (isCustom) {
                    addDesRF({value: el.name}, true);
                } else {
                    addDesRF({
                        value: el.name, 
                        category: el.isAthletics ? 'Athletics' : null
                    });
                }
            }
            
            // add the amount and percent
            document.querySelector('.gfield_repeater_item:last-child .gfield_repeater_cell:nth-child(2) input').value = el.amount;
            document.querySelector('.gfield_repeater_item:last-child .gfield_repeater_cell:nth-child(3) input').value = el.percent;

        })
        // if there's only one row, disable the percent input. Otherwise, enable all of them
        decidePercentageInputROStatus();
        
        // determine if there are Athletics designations in the mix and set radio button appropriately
        setAthleticsRadioValue();

        // set the row arias
        setRowArias(repeaterCont);
        setCorrectRFIDs();
    }

    // add aria-pressed attribute to dollar buttons
    [].forEach.call(dolButtons, btn => btn.setAttribute('aria-pressed', false));

    /* B) PREPERATION ON LOAD / RELOAD
     * */

    // 1. add elements to the Selected Designations repeater box

    repeaterCont.setAttribute('role', 'table');
    repeaterCont.setAttribute('aria-label', 'Selected Designations');
    repeaterCont.setAttribute('aria-colcount', '4');

    const editButton = document.createElement('button');
    editButton.innerText = 'Edit'
    editButton.setAttribute('class', 'edit-other-des');

    const nameText = document.createElement('p');
    nameText.innerText = 'Name';
    nameText.setAttribute('class', 'repeater-label');
    nameText.setAttribute('role', 'columnheader');
    nameText.setAttribute('aria-colindex', '1');
 
    const amountText = document.createElement('p');
    amountText.innerText = 'Amount';
    amountText.setAttribute('class', 'repeater-label');
    amountText.setAttribute('role', 'columnheader');
    amountText.setAttribute('aria-colindex', '2');
 
    const percentageText = document.createElement('p');
    percentageText.innerText = 'Percentage';
    percentageText.setAttribute('class', 'repeater-label');
    percentageText.setAttribute('role', 'columnheader');
    percentageText.setAttribute('aria-colindex', '3');
     
    const deleteText = document.createElement('p');
    deleteText.innerText = 'Delete';
    deleteText.setAttribute('class', 'repeater-label delete-text');
    deleteText.setAttribute('role', 'cell');
    deleteText.setAttribute('aria-colindex', '4');
 
    const textGroupWrapper = document.createElement('div');
    const textGroup = document.createElement('div');
    textGroupWrapper.setAttribute('class', 'top-text-row-wrapper');
    textGroupWrapper.setAttribute('role', 'rowgroup');

    textGroup.setAttribute('class', 'top-text-row');
    textGroup.setAttribute('role', 'row')
    textGroup.setAttribute('aria-rowindex', '1')
    textGroup.append(nameText, amountText, percentageText, deleteText);
    textGroupWrapper.append(textGroup);

    repeaterItems.before(editButton, textGroupWrapper);

    const totalText = document.createElement('p');
    totalText.innerText = 'Total';
    totalText.setAttribute('class', 'repeater-label');
    totalText.setAttribute('role', 'rowheader');
    totalText.setAttribute('aria-colindex', '1');

    const addOrEditButton = document.createElement('button');
    addOrEditButton.setAttribute('id', 'addOrEditButton');
    addOrEditButton.setAttribute('class', 'addOrEditButton');
    addOrEditButton.innerText = 'Add/Edit Designations';

    repeaterItems.after(addOrEditButton);

    const totalDollarRO = document.createElement('input');
    totalDollarRO.readOnly = true;
    totalDollarRO.setAttribute('id', 'totalDollarRO');
    totalDollarRO.setAttribute('aria-label', 'Total Dollars Between Designations');
    totalDollarRO.setAttribute('aria-colindex', '2');

    const totalPercentageRO = document.createElement('input');
    totalPercentageRO.readOnly = true;
    totalPercentageRO.setAttribute('id', 'totalPercentageRO');
    totalPercentageRO.setAttribute('aria-label', 'Total Percentage Between Designations');
    totalPercentageRO.setAttribute('role', 'cell');
    totalPercentageRO.setAttribute('aria-colindex', '3');
    totalPercentageRO.setAttribute('aria-colspan', '2');
    
    const totalGroupWrapper = document.createElement('div');
    totalGroupWrapper.setAttribute('role', 'rowgroup');

    const totalGroup = document.createElement('div');
    totalGroup.setAttribute('class', 'bottom-text-row');
    totalGroup.setAttribute('role', 'row');
    totalGroup.append(totalText, totalDollarRO, totalPercentageRO);

    totalGroupWrapper.append(totalGroup)

    repeaterItems.after(totalGroupWrapper);
    setRowArias(repeaterCont);
    setCorrectRFIDs();

    const repItems = document.querySelector('.gfield_repeater_items');
    repItems.setAttribute('role', 'rowgroup');

    // 2. HTML FOR OTHER DES CHECKBOXES (goes through every designation in allDes)
    const checkboxHTML = allDes.reduce((
        prev,
        {
            category,
            label,
            value
        }, 
        i, 
        arr
    ) => {
        // create elements for every designation with all the data with which we'll need to empower the checkboxes
        const desInfo = `<div class="designation" data-name="${label}" data-category="${category}" data-custom="false">
            <input id="des-${i + 1}" name="des-${i + 1}" data-desvalue="${value}" data-category="${category}" class="designation-checkbox" type="checkbox" value="${i + 1}" data-custom="false" />
            <div class="label-wrapper">
                <label for="des-${i + 1}">${label}</label>
            </div>
        </div>`;

        // grab the last category to check against the current one.
        const priorCategory = i > 0 ? arr[i - 1].category : null; 

        const closingFieldset = i === 0 ? '' : '</fieldset>'

        // If the previous and current category don't match, it means we have a new category--thus we return the new cat's name. Regardless, we also return the designation checkbox els
        return i === 0 || category !== priorCategory ?
            `${prev}
            ${closingFieldset}
            <fieldset>
                <legend class="des-cat" data-category="${category}"><h2>${category}</h2></legend>
                ${desInfo}` :
            prev + desInfo
    }, '');

    // add all the checkboxes to the form (as well as custom designation label)
    designationCheckboxes.innerHTML = `
        ${checkboxHTML}
        <fieldset id='otherDesFieldSet'>
            <legend class="des-cat" data-category="Other Designations"><h2>Other Designations</h2></legend>
        </fieldset>
    `;

    // custom designation checkboxes
    const displayCustomDesInModal = () => {

        // grab the custom designations and display them
        const customDesignations = document.querySelectorAll(c_desInputs + '[data-custom="true"]');
        [].forEach.call(customDesignations, des => {
            const desValue = des.getAttribute('data-desvalue');
            
            const desDiv = document.createElement('div');
            desDiv.classList = 'designation';
            desDiv.setAttribute('data-name', des.value);
            desDiv.setAttribute('data-category', 'Other Designations');
            desDiv.setAttribute('data-custom', 'true');

            const desInput = document.createElement('input');
            desInput.classList = 'designation-checkbox';
            desInput.id = desValue;
            desInput.setAttribute('data-desvalue', desValue);
            desInput.setAttribute('data-custom', 'true');
            desInput.setAttribute('type', 'checkbox');
            desInput.value = desValue;
            desInput.checked = true;

            const desLabelWrapper = document.createElement('div');
            desLabelWrapper.classList = 'label-wrapper';

            const desLabel = document.createElement('label');
            desLabel.setAttribute('for', desValue);
            desLabel.innerText = des.value;

            desLabelWrapper.append(desLabel);

            desDiv.append(desInput, desLabelWrapper);

            const otherDesFieldset = document.getElementById('otherDesFieldSet');
            otherDesFieldset.append(desDiv);
        });

        // put the "Add a custom Designation" checkbox at the bottom

        const customDiv = document.createElement('div');
        customDiv.classList = 'designation';
        customDiv.setAttribute('data-name', 'Add a Designation');
        customDiv.setAttribute('data-category', 'Other Designations');
        customDiv.setAttribute('data-custom', 'true');
        customDiv.setAttribute('data-initial', 'true');

        const customInput = document.createElement('input');
        customInput.classList = 'designation-checkbox';
        customInput.id = 'des-enter';
        customInput.setAttribute('data-desvalue', 'Add a Designation');
        customInput.setAttribute('data-custom', 'true');
        customInput.setAttribute('data-initial', 'true');
        customInput.setAttribute('type', 'checkbox');
        customInput.value = 'enter';

        const customLabelWrapper = document.createElement('div');
        customLabelWrapper.classList = 'label-wrapper';

        const customLabel = document.createElement('label');
        customLabel.setAttribute('for', 'des-enter');
        customLabel.innerText = 'Add a Designation';

        customLabelWrapper.append(customLabel);

        customDiv.append(customInput, customLabelWrapper);

        designationCheckboxes.append(customDiv);
    }

    const removeCustomDesInModal = () => {
        const designations = document.querySelectorAll('.designation-checkboxes .designation[data-custom="true"]');
        [].forEach.call(designations, des => {
            des.remove();
        })
    }

    // 3. Determine if the Other Designation Type was clicked. If so, display either the other des checkbox or repeating fields (if other des's already selected). If not, remove elements that shouldn't be there
    const checked_dtype = document.querySelector('.dtype input:checked');
    if (!checked_dtype || checked_dtype.value !== 'Other') {
        // find all repeater elements
        const repeaters = document.querySelectorAll('.gfield_repeater_item');
        const numOfRepeaters = repeaters.length;

        // remove all repeaters except the last one
        [].forEach.call(repeaters, (el, i) => {
            if ( i + 1 < numOfRepeaters ) {
                gformDeleteRepeaterItem(el.querySelector('.remove_repeater_item'));
            }
        });

        // with only one remaining, get that and remove all its inputs
        const remInps = document.querySelectorAll('.gfield_repeater_item input');
        [].forEach.call(remInps, inp => inp.value = '');
        hideRep();
        hideOtherDes();
    } else {
        // if Other is the Designation, first determine if there's anything in the repeaters
        if (repInpsHaveValues()) {
            hideOtherDes();

            // check for repeating valus that should be there;
            loadRepeatingInputsLS();
            
            showRep();
            if (getTotal() != '') {
                updateRemainingTotal();
                updateRemainingPercent();
            }

        } else {
            showOtherDes();
        }
    }

    // handle checking off the correct other designation inputs if repeater elements are there
    const initialOtherDesCheck = () => {

        // get all repeating inputs
        const rfDesInputs = document.querySelectorAll(c_desInputs);

        // next, see if there's any names in the inps that need to be checked off
        const desvaluesToCheck = [].map.call(rfDesInputs, inp => inp.value);

        // other des checkboxes
        [].forEach.call(desvaluesToCheck, desvalue => {
            const checkbox = document.querySelector(`.designation-checkbox[data-desvalue="${desvalue}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        })
    }
    initialOtherDesCheck();

    // go through every designation and check off the ones we have already
    const allDesInputs = document.querySelectorAll('.gfield_repeater_item .gfield_repeater_cell:nth-child(1) input');
    [].forEach.call(allDesInputs, inp => {
        const name = inp.value;
        const desCheck = document.querySelector(`.designation[data-name="${name}"] input`);
        if (desCheck) {
            desCheck.checked = true;
        }
    });

    // If there are errors in the repeating field, add "Error:" to the start of their text
    const repeaterErrors = document.querySelectorAll('.gfield_repeater_cell .validation_message');
    [].forEach.call( repeaterErrors, el => el.innerHTML = `<strong>Error:</strong> ${el.innerHTML}` );

    // 4. ADDITIONAL HELPERS (now that new els are available)

    // function for when there's only two repeating els and the percent/dollars change.
    const theOtherOne = (total, container, percentEl, dollarEl) => {
        // get the index of the container and make sure the el you want is different
        const parContainer = document.querySelector('.gfield_repeater_items');
        const theOtherIndex = [].indexOf.call(parContainer.children, container) == 0 ? 2 : 1;

        // get the other dollar input
        const otherContainer = document.querySelector(`.gfield_repeater_item:nth-child(${theOtherIndex})`);
        const otherDollarEl = otherContainer.querySelector('.gfield_repeater_cell:nth-child(2) input');
        const otherPercentEl = otherContainer.querySelector('.gfield_repeater_cell:nth-child(3) input');

        // give other dollar input the remaining dollars 
        otherDollarEl.value = '$' + (total - dollarEl.value.replace(/[^0-9.]/, '')).toFixed(2).replace('.00', '');
        otherPercentEl.value = (100 - percentEl.value.replace(/[^0-9.]/, '')).toFixed(1).replace('.0', '');

        // update the hidden remaining percent/total fields
        updateRemainingTotal();
        updateRemainingPercent();
    }

    const uncheckOtherDesBoxes = () => {
        const checkedOthers = document.querySelectorAll('.designation-checkbox:checked');
        [].forEach.call(checkedOthers, inp => inp.checked = false);
    }

    // count the number of designations visible, and display that number
    const countOtherDesResults = () => {
        if (otherDesResults) {
            const allDes = document.querySelectorAll('.designation-checkboxes .designation')
            const visibleDes = [].filter.call(
                allDes,
                el => !hasClass(el, 'hidden-des')
            );
            otherDesResults.innerText = allDes.length == visibleDes.length 
                ? `Showing All ${visibleDes.length} Designations`
                : `Results: ${visibleDes.length} Designations`;
        }
    }

    // filter the designations based on the value in the filter text input (fired on keyup for desFilter and click for desSearch button)
    const filterDes = () => {
        const filterInp = document.querySelector(c_desFilter);
        const filterText = filterInp.value != '' ? (filterInp.value).trim().toLowerCase() : filterInp.value;

        // get each des
        const designations = document.querySelectorAll('.designation-checkboxes .designation');

        // go through each one and add/remove hidden class based on text
        [].forEach.call(designations, des => {
            if (filterText == '') {
                removeClass(des, 'hidden-des');
            } else if (des.getAttribute('data-name').toLowerCase().indexOf(filterText) === -1) {
                if (!hasClass(des, 'hidden-des') && des.getAttribute('data-custom') == 'false') {
                    addClass(des, 'hidden-des');
                }
            } else {
                removeClass(des, 'hidden-des');
            }
        });

        // check each category el, and hide if need to
        theCats.forEach(cat => {
            if (document.querySelectorAll(`.designation[data-category="${cat}"]:not(.hidden-des)`).length == 0) {
                if (!hasClass(document.querySelector(`.des-cat[data-category="${cat}"]`), 'hidden-cat')) {
                    addClass(document.querySelector(`.des-cat[data-category="${cat}"]`), 'hidden-cat');
                };
            } else {
                removeClass(document.querySelector(`.des-cat[data-category="${cat}"]`), 'hidden-cat');
            }
        })

        // count the number of designations visible, and display that number
        countOtherDesResults();
        
    }

    const allocateDollarsInitial = desNumber => {

        if (desNumber === 0 ) {
            return;
        }
        // grab the total
        const total = getTotal();

        // if there's no total, stop the function
        if (total.toString().length == 0) {
            return;
        }

        const init_distribution = Math.floor((total / desNumber) * 100) / 100;
        const almost_total = (init_distribution * desNumber).toFixed(2);
        const remaining = (+(total - almost_total)).toFixed(2);

        const distributants = [...(new Array(desNumber))].map(el => +init_distribution);

        // dole out a cent from the remaining cost until no more remains
        const f_distributants = distributants.map((dis, i) => {
            const whatsLeft = (+(+remaining - ((i + 1) * 0.01)).toFixed(2));
            return whatsLeft < 0 ? +dis : (+(+dis + 0.01).toFixed(2));
        });

        // add dollars to each input
        const dollarEls = document.querySelectorAll(c_dollarInputs);

        [].forEach.call(dollarEls, (inp, i) => inp.value = '$' + f_distributants[i].toFixed(2).replace('.00', ''));
        
    }

    const allocateDollars = () => {

        // grab the total
        const total = getTotal();

        // if there's no total, stop the function
        if (total.toString().length == 0) {
            return;
        }

        // grab dollar inputs changed and unchanged
        const changedDollarInputs = document.querySelectorAll(c_dollarInputsChanged);
        const unchangedDollarInputs = document.querySelectorAll(c_dollarInputsUnchanged);
        const desNumber = unchangedDollarInputs.length;

        // don't run this if there's no inputs left to balance
        if (desNumber == 0) {
            return;
        }
        
        // get total from the changed dollar inputs
        const changedInputTotal = [].reduce.call(changedDollarInputs, (car, inp) => {
            const val = inp.value != '' && !isNaN(+(inp.value.replace('$', ''))) ? 
                +(inp.value.replace('$', '')) :
                0;
            return car + val;
        }, 0).toFixed(2);

        const alteredTotal = total - changedInputTotal;


        const init_distribution = Math.floor((alteredTotal / desNumber) * 100) / 100;
        const almost_total = (init_distribution * desNumber).toFixed(2);
        const remaining = (+(alteredTotal - almost_total)).toFixed(2);

        const distributants = [...(new Array(desNumber))].map(el => +init_distribution);

        // dole out a cent from the remaining cost until no more remains
        const f_distributants = distributants.map((dis, i) => {
            const whatsLeft = (+(+remaining - ((i + 1) * 0.01)).toFixed(2));
            return whatsLeft < 0 ? +dis : (+(+dis + 0.01).toFixed(2));
        });

        // add dollars to each unchanged input
        [].forEach.call(unchangedDollarInputs, (inp, i) => {
            inp.value = '$' + f_distributants[i].toFixed(2).replace('.00', '')
            inp.value = inp.value.replace('$-', '-$');
        });
        
    }

    // allocate percentages
    const allocatePercentages = () => {

        // grab the total
        const total = getTotal();

        // if there's no total, stop the function
        if (total.toString().length == 0) {
            return;
        }

        // grab all input values for dollars
        const dollarEls = document.querySelectorAll(c_dollarInputs);
        const dollarVals = [].map.call(dollarEls, inp => inp.value.replace('$', ''));

        // grab all the input els for percentage
        const percentageInps = document.querySelectorAll(c_percentageInputs);

        // find the percentage of each dollar based on the total, save in an array of obj with index as a key, as well as one float parsed to 1.
        const percentages = dollarVals.map((val, index) => {
            const value = isNaN(val) ? 0 : val;
            const percent = (value / total) * 100;
            const longEnough = percent.toString().split(/\./).length > 1 ? percent.toString().split(/\./)[1].length > 1 : false;
            return ({
                index,
                percent: (value / total) * 100,
                f_percent: longEnough ? Math.floor((value / total) * 1000) / 10 : (value / total) * 100
            })
        })

        // find the sum of all the float parsed ones, then subtract from 100 (float parse this dif to one as well)
        const remaining = +(100 - (percentages.reduce((prev, cur) => prev + cur.f_percent, 0)).toFixed(1));

        // sort the order of the object (immutably) based on rank of the percent that falls after the first decimal
        const s_percentages = [...percentages].sort((a, b) => {
            const remainder_of_a = a.percent.toString().split(/\.\d/).length < 2 ? 0 : +(a.percent.toString().split(/\.\d/)[1]);
            const remainder_of_b = b.percent.toString().split(/\.\d/).length < 2 ? 0 : +(b.percent.toString().split(/\.\d/)[1]);
            return +('.' + remainder_of_b) - +('.' + remainder_of_a);
        })

        // keep adding .1 until we get to 100%
        const f_percentages = s_percentages.map((o_per, i) => {
            const whatsLeft = +(remaining - ((i + 1) * 0.1)).toFixed(1);
            return whatsLeft < 0 ? 
                o_per : 
                ({
                index: o_per.index,
                percent: o_per.percent,
                f_percent: +(+(o_per.f_percent) + 0.1 ).toFixed(1) 
                })
        });

        // add the percentages back to the proper inputs based on key
        f_percentages.forEach(o_per => {
            document.querySelector(`.gfield_repeater_item:nth-child(${+(o_per.index) + 1}) .gfield_repeater_cell:nth-child(3) input`).value = o_per.f_percent.toFixed(1).replace('.0', '')
        });
    }

    /* C) Form Event Handlers
     * */

    // determine if we need to swap the amount button values based on giving type
    const handle_gtype_click = e => {

        // determine dollar amounts and whether we need to switch them
        const amounts = e.currentTarget.value !== 'Recurring Gift' ? stdAmounts : recurAmounts;
        const shouldSwitch = dolButtons[0].value != amounts[0];

        otherDesWrapper.display = 'none';

        if (shouldSwitch) {
            // remove the amount input value
            amountInput.value = '';
            amountInput.dispatchEvent(new Event('change'));
            jQuery(c_amountInput).change();

            // swap the button values 
            [].forEach.call(dolButtons, (btn, i) => {                
                btn.value = amounts[i];
                btn.innerText = amounts[i] !== 1000 ? `$${amounts[i]}` : '$1,000'; 
            });
        }
        
        // if it's a pledge payment, hide the inputs we would hide if Other was not selected
        if (e.currentTarget.value == 'Pledge Payment') {
            removeAllDesRF();
            hideOtherDes();
            hideRep();
            uncheckOtherDesBoxes();
            const remTotalInp = document.querySelector(c_remainingTotal);
            remTotalInp.value = 0;
            totalDollarRO.value = 0;
            jQuery(c_remainingTotal).change();
            const remPerInp = document.querySelector(c_remainingPercent);
            remPerInp.value = 0;
            totalPercentageRO.value = 0;
            jQuery(c_remainingPercent).change();
        }
    }
    
    const handle_dtype_click = e => {
        if (e.currentTarget.value !== 'Other') {
            removeAllDesRF();
            hideOtherDes();
            hideRep();
            uncheckOtherDesBoxes();
            const remTotalInp = document.querySelector(c_remainingTotal);
            remTotalInp.value = 0;
            totalDollarRO.value = 0;
            jQuery(c_remainingTotal).change();
            const remPerInp = document.querySelector(c_remainingPercent);
            remPerInp.value = 0;
            totalPercentageRO.value = 0;
            jQuery(c_remainingPercent).change();
        } else {
            hideRep();
            showOtherDes();
        }
    }

    // dollar button click
    const handle_dolButton_click = e => {

        // don't run this if button is already pressed
        if (hasClass(e.currentTarget, 'pressed')) {
            return;
        }

        // make total amount reflect the button
        amountInput.value = `$${e.currentTarget.value}`;
        amountInput.dispatchEvent(new Event('change'))
        jQuery(c_amountInput).change();

        // remove pressed class aria-pressed property from previously selected btn, if any
        [].forEach.call(dolButtons, btn => {
            if (btn.getAttribute('aria-pressed') == 'true') {
                btn.setAttribute('aria-pressed', false);
                removeClass(btn, 'pressed');
            }
        });
        
        // add aria-pressed to the pressed button
        addClass(e.currentTarget, 'pressed');
        e.currentTarget.setAttribute('aria-pressed', 'true');
    }

    // repeating element percent input change
    const handle_percent_change = ({currentTarget: percentEl}) => {
        const total = getTotal();
        if (total.toString().length == 0 && percentEl.value.replace(/[^0-9]/g, '') != '') {
            return;
        }

        // find which nth child the repeater is
        const container = findAncestor(percentEl, 'gfield_repeater_item');

        // based on that, grab the adjacent dollar input
        const dollarEl = container.querySelector('.gfield_repeater_cell:nth-child(2) input');

        // compare percent to total, make a dollar amount (two dec)
        const perVal = (percentEl.value.replace(/[^0-9.]/g, '') / 100).toFixed(3);
        const dollarVal = '$' + (perVal * total).toFixed(2).replace('.00', '');

        // replace old dollar amount with new
        dollarEl.value = dollarVal;

        // add data-changed to els to mark them for future allocations
        dollarEl.setAttribute('data-changed', 'true');
        percentEl.setAttribute('data-changed', 'true');
        
        // if there's only two repeaters, make the other inputs the inverse of the dollars and percents
        if (document.querySelectorAll('.gfield_repeater_item').length == 2 ) {
            theOtherOne(total, container, percentEl, dollarEl);
            return;
        } 
        
        // if percent is now equal to 100, check all dollars to see if they add up
        const allPerInps = document.querySelectorAll(c_percentageInputs);
        const totalPercent = [].reduce.call(allPerInps, (prev, cur) => +(prev + (+cur.value)).toFixed(1), 0);
        
        // check for length of unchanged inputs. If none, don't run dollar and percent allocation
        const hasUnchangedPercents = document.querySelectorAll(c_percentInputsUnchanged).length > 0;

        if (hasUnchangedPercents) {
            allocateDollars();
            allocatePercentages();
        } else if (totalPercent == 100) {
            
            // if not but the 
            const allDollarInps = document.querySelectorAll(c_dollarInputs);
            const totalDollars = [].reduce.call(allDollarInps, (prev, cur) => +(prev + (+cur.value)).toFixed(2), 0);
            
            
            // if all percentages add up but the dollar amount is bad, reset all dollar amounts based on percent
            if (totalDollars != total) {
                const dollars = [].map.call(allDollarInps, (inp, index) => {
                    const curContainer = findAncestor(inp, 'gfield_repeater_item');
                    const adjPer = curContainer.querySelector('.gfield_repeater_cell:nth-child(3) input');
                    const percent = adjPer.value != '' ? (adjPer.value / 100).toFixed(3) : 0;
                    const dollar = (percent * total);
                    const f_dollar = Math.floor(dollar * 100) / 100;
                    return ({
                        index,
                        dollar,
                        f_dollar
                    })
                });

                // dole out cents using highest remainder method
                const almost_total = dollars.reduce((prev, cur) => +(prev + (+cur.f_dollar)), 0);
                const remaining = total - almost_total;

                // sort the order of the object (immutably) based on rank of the dollars that falls after the second decimal
                const s_dollar = remaining == 0 ?
                    [...dollars] :
                    [...dollars].sort((a, b) => {
                        const remainder_of_a = a.dollar.toString().split(/\.\d\d/).length < 2 ? 0 : +(a.dollar.toString().split(/\.\d\d/)[1]);
                        const remainder_of_b = b.dollar.toString().split(/\.\d\d/).length < 2 ? 0 : +(b.dollar.toString().split(/\.\d\d/)[1]);
                        return +('.' + remainder_of_b) - +('.' + remainder_of_a)
                    });

                // keep adding .01 until we run out of cents
                const f_dollars = s_dollar.map((o_dol, i) => {
                    const whatsLeft = +(remaining - ((i + 1) * 0.01)).toFixed(2);
                    return whatsLeft < 0 ? 
                        o_dol : 
                        ({
                            index: o_dol.index,
                            dollar: o_dol.dollar,
                            f_dollar: +(+(o_dol.f_dollar) + 0.01 ).toFixed(2) 
                        });
                });
                

                // add the dollars back to the proper inputs based on key
                f_dollars.forEach(o_dol => {
                    document.querySelector(`.gfield_repeater_item:nth-child(${+(o_dol.index) + 1}) .gfield_repeater_cell:nth-child(2) input`).value = '$' + o_dol.f_dollar.toFixed(2).replace('.00', '');
                });
            }
        }

        updateRemainingTotal();
        updateRemainingPercent();
        saveRepeatingInputsLS(); // local storage
    }

    // repeating element dollar input change
    const handle_dollar_change = ({currentTarget: dollarEl}) => {
        
        // grab total amount from the form's primary amount input
        const total = getTotal();

        // if there's no amount designated or the dollar entered isn't valid, skip this function
        if (total.toString().length == 0 && dollarEl.value.replace(/[^0-9]/g, '')) {
            return;
        }

        /* If there's only one row of repeating fields, change the total, too.
         * But if f there's more than one row, we're going to change the adjacent percent to match
         * */
        if (document.querySelectorAll('.gfield_repeater_item').length == 1) {
            amountInput.value = `$${(+(dollarEl.value.replace(/[^0-9.]/g, ''))).toFixed(2)}`;
            amountInput.dispatchEvent(new Event('change'))
            jQuery(c_amountInput).change();
        } else {
            // find which nth child the repeater is
            const container = findAncestor(dollarEl, 'gfield_repeater_item');

            // based on that, grab the adjacent percent input
            const percentEl = container.querySelector('.gfield_repeater_cell:nth-child(3) input');

            // divide current dollar by total, multiply by 100
            const percentVal = ((dollarEl.value.replace(/[^0-9.]/g, '') / total) * 100).toFixed(1).replace('.0', '');

            // replace old percent amount with new
            percentEl.value = percentVal;

            // add data-changed to els to mark them for future allocations
            dollarEl.setAttribute('data-changed', 'true');
            percentEl.setAttribute('data-changed', 'true');

        }

        // if there's only two repeaters, alter the other one so that percent and dollars add up
        if (document.querySelectorAll('.gfield_repeater_item').length == 2 ) {
            theOtherOne(total, container, percentEl, dollarEl);
        } else {
            allocateDollars();
            allocatePercentages();
            updateRemainingTotal();
            updateRemainingPercent();
        }
        saveRepeatingInputsLS(); // local storage
    }

    // other designation cancel button click
    const handle_cancel = e => {
        e.preventDefault();
        hideOtherDes();
        if (!repInpsHaveValues()) {
            hideRep();
            const otherCheck = document.querySelector('.dtype input:checked');
            if (otherCheck) {
                otherCheck.checked = false;
                jQuery(otherCheck).change();
            }
        } else {
            showRep();
        }
    }

    // other designation continue button click
    const handle_continue_click = e => {
        e.preventDefault();

        // check to see if designation was clicked. If not, display (not clicked) message
        const desChecked = document.querySelectorAll('.designation-checkbox:checked');
        if (desChecked.length == 0) {
            // make border of area red
            otherDesWrapper.style.border = '1px solid #c02b0a';
            otherDes.style.border = '1px solid #c02b0a';

            errMsg.innerHTML = '<p>Please select at least one designation.</p>'
            // stop the function
            return;
        } else {
            otherDesWrapper.style.border = null;
            otherDes.style.border = null;
            errMsg.innerHTML = '';
        }

        // next, see if there's any names that have ids that aren't checked off (remove)
        const rfDesInputs = document.querySelectorAll(c_desInputs);

        // NON-CUSTOM
        // next, see if there's any names in the inps that need to be added (add)
        const desToAdd = [].map.call(desChecked, des => (des.value - 1) < allDes.length ? allDes[des.value - 1] : null)
            .filter(des => des !== null);

        const desNotYetAdded = desToAdd.filter(des => {
            return !([].some.call(rfDesInputs, inp => {
                return inp.value === des.value
            }))
        })
        
        desNotYetAdded.forEach(des => addDesRF(des));
        
        const desInpToRem = [].filter.call(rfDesInputs, inp => !(inp.hasAttribute('data-custom')) && !(desToAdd.some(des => inp.value === des.value))); 

        [].forEach.call(desInpToRem, inp => removeDesRF(inp));


        // CUSTOM DESIGNATIONS
        const customChecked = document.querySelector('.designation-checkbox[data-initial="true"]:checked');

        if (customChecked != null) {
            addDesRF(customChecked);
        }
        

        // if there's an 'enter' custom des checked, create a new designation with an editable field
        const customUnchecked = document.querySelectorAll('.designation-checkbox[data-custom="true"]:not(:checked):not([data-initial="true"]');

        if (customUnchecked.length > 0) {
            const customToRem = [].filter.call(rfDesInputs, inp => [].some.call(customUnchecked, des => {

                const inpVal = inp.getAttribute('data-desvalue');
                const desVal = des.getAttribute('data-desvalue');
    
                return inpVal == desVal;
            })); 
            [].forEach.call(customToRem, inp => removeDesRF(inp));
        }
        
        hideOtherDes();

        // finally, if there's a total, split the dollars and percents as equally as possible.
        // make a variable to determine if any dollar fields have a number in them
        const dollarEls = document.querySelectorAll(c_dollarInputs);
        const dollarElHasValue = [].some.call(dollarEls, inp => inp.val !== '');
        
        // if there's no dollar field values, run findDistributants(total, desNumber)
        if (dollarElHasValue) {
            allocateDollarsInitial(dollarEls.length);
            allocatePercentages();
        }

        // show the repeating fields and update the remaining percent and remaining total fields
        showRep();
        updateRemainingTotal();
        updateRemainingPercent();

        // check if there are any athletics designations. Set radio button appropriately
        setAthleticsRadioValue();

        // if there's only one row, disable the percent input. Otherwise, enable all of them
        decidePercentageInputROStatus();

        // save the repeating input values in local storage
        saveRepeatingInputsLS();
    }

    // total amount input value change
    const handle_amtInput_change = e => {

        const total = (e.currentTarget.value).replace('$', '').replace(',', '').replace('.00', '').replace('.0', '').replace('.', '');

        // check pressed button. if amt no longer matches, remove pressed status
        const btn = document.querySelector('.dollar-buttons button.pressed');
        if (btn && btn.value != total) {
            btn.setAttribute('aria-pressed', 'false');
            removeClass(btn, 'pressed');
        }
        
        const dollarInputs = document.querySelectorAll(c_dollarInputs);
        const percentInputs = document.querySelectorAll(c_percentageInputs);

        // don't do this if no dollar inputs (no repeating fields yet)
        if (dollarInputs.length == 0) {
            return;
        }
        
        // if there are dollar inputs, remove data-changed from all of them
        removeDataChangedAttrs();

        if (total.length == 0 || total == 0) {
            [].forEach.call(dollarInputs, inp => inp.value = 0)
            totalDollarRO.value = 0;
            [].forEach.call(percentInputs, inp => inp.value = '')
            totalPercentageRO.value = '%';
            return;
        }
        
        // check whether one percent field is set
        const atLeastOnePercent = [].some.call(percentInputs, inp => inp.value != '' && +(inp.value) > 0)
        const atLeastOneDollar = [].some.call(dollarInputs, inp =>{
            return inp.value != '' && +(inp.value.replace('$', '')) > 0
        } )

        // check whether the sum of all percents is greater than 100,
        const sum = [].reduce.call(percentInputs, (acc, inp) => {
            return inp.value.length > 0 ? 
                +(inp.value) + acc :
                acc;
        }, 0);

        //  check if any percent is greater than 100 or less than 1
        const badPercent = [].some.call(percentInputs, inp => {
            return inp.value.length > 0 ?
                +(inp.value) > 100 || +(inp.value) <= 0 :
                false;
        }) 

        if (sum > 100 || badPercent) {
            allocateDollarsInitial(dollarInputs.length);
            allocatePercentages();
        } else if (atLeastOnePercent) {
            // remove any dollar inputs from other des
            [].forEach.call(dollarInputs, inp => inp.value = '');
            // check that percentages are set. 
            [].forEach.call(percentInputs, inp => inp.value == '' ? inp.value = '0' : inp.value = inp.value);

            // make related dollar input match percentage
            [].forEach.call(dollarInputs, (inp, i) => {
                const percent = document.querySelector(`.gfield_repeater_item:nth-child(${i+1}) .gfield_repeater_cell:nth-child(3) input`).value;
                const desDolVal = (((+total) * (+percent)) / 100).toFixed(2);
                inp.value = '$' + desDolVal;
            })

            // if percent is now equal to 100, check all dollars to see if they add up
            const allPerInps = document.querySelectorAll(c_percentageInputs);
            const totalPercent = [].reduce.call(allPerInps, (prev, cur) => +(prev + (+cur.value)).toFixed(1), 0);
            const allDollarInps = document.querySelectorAll(c_dollarInputs);
            const totalDollars = [].reduce.call(allDollarInps, (prev, cur) => +(prev + (+cur.value)).toFixed(2), 0);
            
            // if all percentages add up to 100 but the dollar amount is bad, fix the dollar amounts
            if (totalPercent == 100 && totalDollars != total) {
                const dollars = [].map.call(allDollarInps, (inp, index) => {
                    const curContainer = findAncestor(inp, 'gfield_repeater_item');
                    const adjPer = curContainer.querySelector('.gfield_repeater_cell:nth-child(3) input');
                    const percent = adjPer.value != '' ? (adjPer.value / 100).toFixed(3) : 0;
                    const dollar = (percent * total);
                    const f_dollar = Math.floor(dollar * 100) / 100;
                    return ({
                        index,
                        dollar,
                        f_dollar
                    })
                });

                // dole out cents using highest remainder method
                const almost_total = dollars.reduce((prev, cur) => +(prev + (+cur.f_dollar)), 0);
                const remaining = total - almost_total;

                // sort the order of the object (immutably) based on rank of the dollars that falls after the second decimal
                const s_dollar = remaining == 0 ?
                    [...dollars] :
                    [...dollars].sort((a, b) => {
                        const remainder_of_a = a.dollar.toString().split(/\.\d\d/).length < 2 ? 0 : +(a.dollar.toString().split(/\.\d\d/)[1]);
                        const remainder_of_b = b.dollar.toString().split(/\.\d\d/).length < 2 ? 0 : +(b.dollar.toString().split(/\.\d\d/)[1]);
                        return +('.' + remainder_of_b) - +('.' + remainder_of_a)
                    });

                // keep adding .01 until we run out of cents
                const f_dollars = s_dollar.map((o_dol, i) => {
                    const whatsLeft = +(remaining - ((i + 1) * 0.01)).toFixed(2);
                    return whatsLeft < 0 ? 
                        o_dol : 
                        ({
                            index: o_dol.index,
                            dollar: o_dol.dollar,
                            f_dollar: +(+(o_dol.f_dollar) + 0.01 ).toFixed(2) 
                        });
                });
                

                // add the dollars back to the proper inputs based on key
                f_dollars.forEach(o_dol => {
                    document.querySelector(`.gfield_repeater_item:nth-child(${+(o_dol.index) + 1}) .gfield_repeater_cell:nth-child(2) input`).value = '$' + o_dol.f_dollar.toFixed(2).replace('.00', '');
                });
            }
        } else if (!atLeastOneDollar) {
            allocateDollarsInitial(dollarInputs.length);
            allocatePercentages();
        }
        updateRemainingTotal();
        updateRemainingPercent();
    }

    
    // handle resize for when displaying other des modal (and run one time in case modal appears right away)
    const handle_window_resize = () => {
        if ( window.innerWidth >= 500 && document.body.style.position == 'fixed') {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
        recalculatePageHeight(); // height will change for page, so we need to run this for parallax to appear correctly
    }
    

    // 3: ADD THE Event Listeners
    
    // gift type buttons
    [].forEach.call(gtypeButtons, btn => btn.addEventListener('click', handle_gtype_click));

    // dollar buttons
    [].forEach.call(dolButtons, btn => btn.addEventListener('click', handle_dolButton_click));

    // designation type buttons
    [].forEach.call(dtypeButtons, btn => btn.addEventListener('click', handle_dtype_click));

    // when amount input is changed
    amountInput.addEventListener('change', handle_amtInput_change);

    // filter the other designation checkboxes when magnifying glass is clicked
    desSearchBtn.addEventListener('click', e => {
        e.preventDefault();
        filterDes();
    })

    // Filter the other designation checkboxes based on what's typed in the filter input
    desFilter.addEventListener('keyup', filterDes);
    
    // handle the click event for the Cancel Button in the other designation section
    otherCancel.addEventListener('click', handle_cancel);

    // when the other designation is displayed as a modal, clicking outside the modal will hide the field
    document.querySelector('.other-des-wrapper').addEventListener('click', e => {
        if (!hasClass(e.target, 'gfield')) {
            return;
        }
        // perform the same action as the cancel button
        handle_cancel(e);
    })

    // click event for clicking Continue in the Other Designation section
    otherContinue.addEventListener('click', handle_continue_click);

    // When repeater elements display, clicking the Edit Designation buttons will hide the repeating els and display the other des checkboxes
    editButton.addEventListener('click', e => {
        e.preventDefault();
        hideRep();
        showOtherDes();
    });
    addOrEditButton.addEventListener('click', e => {
        e.preventDefault();
        hideRep();
        showOtherDes();
    })

    // exit modal if it's open when hitting ESC
    document.addEventListener('keydown', e => {
        if (e.code === 'Escape' && otherDesWrapper.style.display != 'none') {
            e.preventDefault();
            handle_cancel(e);
        }
    });

    // exit modal when selecting the X button
    if (otherDesCloseBtn) {
        otherDesCloseBtn.addEventListener('click', e => handle_cancel(e));
    }

    // set focus and blur of biographical inputs (removed)

    // add event handlers to dollar and percent inputs (for when page loads)
    const allDolInputs = document.querySelectorAll(c_dollarInputs);
    [].forEach.call(allDolInputs, inp => inp.addEventListener('change', e => {
        editDollars(e);
        handle_dollar_change(e);
    }));

    const allPerInputs = document.querySelectorAll(c_percentageInputs);
    [].forEach.call(allPerInputs, inp => inp.addEventListener('change', e => {
        editPercentage(e);
        handle_percent_change(e);
    }));

    // set window resize handler
    window.addEventListener('resize', handle_window_resize);

    /* Z) Matching Gift Ajax 
     * */

    // Removed on Aug 27, 2024

});

